import { UserInformation } from "src/app/models/profile.model";
import { ReduxWrapper } from "../app.state";

export const profileInitialState: ReduxWrapper<UserInformation | undefined> = {
	error: undefined,
	loadedOnce: false,
	loading: false,
	value: undefined
};
